import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";
require('parsley');

export class memberChangePassword {
	private changePwForm:any   = $('#member-change-password');
	private memberBase:any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr:any   = $.makeArray(_self.changePwForm.find('input[type="password"]'));

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	/**
	 * set confirm password validation to match password field
	 */
	initPasswordInputs(): any {
		let _self = this;
		let passwordId:string = 'member--new-password';
		let confirmPassword:any = _self.changePwForm.find('#member--confirm-new-password');

		confirmPassword.attr('data-parsley-equalto', '#'+passwordId);
	}

	validateForm(): any {
		let _self = this;

		// init password validation
		_self.memberBase.customValidationPasswordAlphanum();
		_self.memberBase.customValidationPasswordMinAlpha();

		_self.memberBase.validateForm(_self.changePwForm,
			function(validation: any) {
				// all your custom validation here
				let changePassword = _self.changePwForm.find('#member--new-password, #member--confirm-new-password');
				changePassword.each((i:number, el:any) => {
					$(el).attr({
						'data-parsley-mh-password-alphanum': true,
						'data-parsley-mh-password-min-alpha': true,
						'minlength': '6',
						'maxlength': '12',
						'data-parsley-minlength': '6',
						'data-parsley-maxlength': '12'
					});
				});
			},
			function(validation: any, formData:any) {
				// on success function
				let submitBtn = _self.changePwForm.find('#change-password--submit');
				let successMsg = _self.changePwForm.parents().eq(1).find('#password-change-success');

				submitBtn.fadeOut();
				successMsg.fadeIn();
			}
		);
	}

}

let scope:Element = document.querySelector('#member-change-password');
if (scope) {
	try {
	let memberchangepassword = new memberChangePassword();
	memberchangepassword.initPasswordInputs();
	memberchangepassword.initTextInputs();
	memberchangepassword.validateForm();
	} catch(e) {console.error(e);}
}
